import { useEffect } from 'react'
import { MdClose } from 'react-icons/md'
import MonopolioLogo from '../../assets/svg/monopolio-logo-small.svg'
import Thunderbolt from '../../assets/svg/thunderbolt.svg'
import { useSearchEngineStore } from '../../stores/searchStore'
import { IReturnState } from '../../stores/searchStore/types'
import { AddressAutoComplete } from './components/AddressAutoComplete'
import { ShareCommission } from './components/ShareCommission'
import { OperationType } from './components/OperationType'
import { PropertyType } from './components/PropertyType'
import { MaxBudget } from './components/MaxBudget'
import { FormIlustration } from './components/FormIlustration'
import { composeClasses } from '@wiggot/utils/src/strings'

interface Props {
  variant: string
  ilustrationContainerClassName?: string
  ilustrationSubtitleClassName?: string
  formContainerClassName?: string
  isActiveButtonClassName?: string
  buttonClassName?: string
  onClickFunc: (args: IReturnState) => void
  onCloseFunc: () => void
}

const SearchForm = ({
  variant,
  ilustrationContainerClassName,
  ilustrationSubtitleClassName,
  formContainerClassName,
  isActiveButtonClassName,
  buttonClassName,
  onClickFunc,
  onCloseFunc
}: Props) => {

  const { 
    propertyTypes,
    maxBudget,
    operationType,
    sharesCommission,
    location,
    setOperationType,
    reset
  } = useSearchEngineStore((state) => state)

  useEffect(( ) =>{
    reset()
    if(variant === 'LEASE'){
      setOperationType('for-lease')
    } else {
      setOperationType('for-sale')
    }
  },[variant])

  return (
    <div className="w-full md:max-h-[40rem] flex rounded-xl md:flex-row flex-col">
      <FormIlustration subtitleClassName={ilustrationSubtitleClassName} variant={variant} onCloseFunc={onCloseFunc} className={ilustrationContainerClassName} />
      <div
        className={composeClasses(
          "md:w-[32.75rem] md:rounded-r-xl md:rounded-l-none max-w-[32.75rem] rounded-b-xl w-full flex flex-col bg-white z-10",
          formContainerClassName
        )}
      >
        <div className="flex justify-between px-6 pt-3 pb-1">
          <div className="flex items-center">
            <span className="text-[0.625rem] font-bold text-[#726E7D]">
              POWERED BY
            </span>
            <img src={MonopolioLogo.src} alt="monopolio" className="ml-1 mr-[0.38rem]" />
            <img src={Thunderbolt.src} alt="monopolio-thunderbolt" />
          </div>
          <button
            className="md:flex hidden w-12 h-12 items-center justify-center hover:bg-[#f7f8fc] rounded-full transition-colors duration-150" 
            onClick={onCloseFunc}
          >
            <MdClose className="w-6 h-6"/>
          </button>
        </div>
        <div className="flex flex-col px-6 py-3 gap-y-6">
          {variant === 'EXPLORE' && <OperationType isActiveButtonClassName={isActiveButtonClassName} />}
          <AddressAutoComplete />
          <MaxBudget />
          <PropertyType isActiveButtonClassName={isActiveButtonClassName} />
          <ShareCommission />
        </div>
        <div className="flex justify-center px-6 py-3 border-solid border-[#EBEDF0] border-t-[1px] ">
          <button
            onClick={() => onClickFunc({ propertyTypes, maxBudget, operationType, sharesCommission, location })}
            type="button"
            className={composeClasses(
              "w-full bg-[#0038FF] cursor-pointer rounded-[50px] transition-all duration-200 ease-out hover:bg-[#0055d3] py-3.5 px-6 text-normal font-semibold text-white text-center",
              buttonClassName
            )}
          >
            Buscar
          </button>
        </div>
      </div>
    </div>
  )
}

export default SearchForm